import { render } from "./hotel-icons.vue?vue&type=template&id=0d2b1cae"
import script from "./hotel-icons.vue?vue&type=script&lang=js"
export * from "./hotel-icons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__